<template>
	<button
		class="site_button"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		:style="{ '--site-button-colour': button_colour, '--min-height' : minHeight + 'px', '--border-thickness': borderThickness + 'px' }"
		:class="{ 'no-border': border === 'no' }"
		ref="site_button"
	>
		<span v-html="button_label ? button_label : button_link.title"></span>
		<div
			class="arrow"
			:class="{ active: hovered === true }"
			v-if="border === 'yes'"
		>
			<svg
				width="70"
				height="19"
				viewBox="0 0 70 19"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M69.669 9.33218L61.3737 0L60.6263 0.664364L67.8865 8.83215H0V9.83215H67.8866L60.6263 18L61.3737 18.6644L69.669 9.33218Z"
				/>
			</svg>
		</div>
	</button>
</template>

<script>
export default {
	data() {
		return {
			button_label: this.label,
			hovered: false,
			button_colour: this.colour.replace('"', ''),
		};
	},

	props: {
		label: {},
		colour: {
			default: '#000',
		},
		border: {
			default: 'yes',
		},
		minHeight: {
			default: '40',
		},
		borderThickness: {
			default: '1',
		},
	},

	computed: {},

	watch: {
	},

	methods: {
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/common/variables';

.site_button {
	border: 1px solid var(--site-button-colour);
	padding: 0 $spacer * 2;
	display: grid;
	grid-template-columns: 1fr auto;
	justify-content: flex-start;
	align-items: center;
	min-height: var(--min-height);
	max-width: calc(100% - 82px);
	width: auto;
	text-decoration: none;
	column-gap: $spacer;
	appearance: none;
	border: 0;
transition: 0.2s ease all;

	&:hover {
		transform: translateY(-5px);
		box-shadow: 5px 5px rgba(#000, 0.5);
		transition: 0.2s ease all;
	}


	@media (max-width: $lg) {
		width: 100%;
	}

	&.no-border {
		border: 0px solid transparent;
		padding: 0 $spacer;
		max-width: calc(100% - 40px);
		column-gap: 0;

		span {
			padding-bottom: $spacer / 2;
			border-bottom: var(--border-thickness) solid var(--site-button-colour);
			text-align: center;
		}
	}

	&:hover {
		cursor: pointer;
	}

	span {
		color: var(--site-button-colour);
		font-size: 20px;
		text-align: center;
	}

	.arrow {
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: center;
		overflow: hidden;
		width: 40px;
		height: 20px;
		transition: 0.2s ease all;

		&.active {
			width: 70px;
			transition: 0.2s ease all;
		}

		svg {
			position: absolute;
			right: 0;
			path {
				fill: var(--site-button-colour);
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteButtonInput.vue